export const checkImeI = (imei: any) => {
  return imei > 8 ? true : false;
};

export const helperTextRender = (imeiValidator: any, message: string) => {
  return imeiValidator ? "" : message;
};

export const validatePhoneNumber = (number: string) => {
  let cleanedNumber = number
    .replaceAll(" ", "")
    .replaceAll("(", "")
    .replaceAll(")", "")
    .replaceAll("-", "")
    .slice(0, 10);
  if (cleanedNumber !== "") {
    if (isNaN(parseInt(cleanedNumber!)) || cleanedNumber?.length !== 10) {
      return "";
    } else {
      cleanedNumber = [
        "(",
        cleanedNumber?.slice(0, 3),
        ")",
        "-",
        cleanedNumber?.slice(3, 6),
        "-",
        cleanedNumber?.slice(6, 10)
      ].join("");
      return cleanedNumber;
    }
  }
};
